// extracted by mini-css-extract-plugin
export default {"btop":"_3f3494dfd6 ddf6c5510a _309fe9dea0","icon":"dd5d85f873 _6e1b244afd","btoppink":"_3d4e4a9dc3 _6a5ba61696"};